import { CategoryDetailsEffects } from './category-details.effects';
import { CategoryTagsEffects } from './category-tags.effects';
import { ProductEffects } from './product.effects';

export const effects: any[] = [ProductEffects, CategoryTagsEffects, CategoryDetailsEffects];
